import IComponent from "components/commons/IComponent";
import "./ItemDetail.scoped.css";
import SwitchButton from "components/commons/SwitchButton";
import SwitchTabs from "components/commons/SwitchTabs";
import BasicInfo from "./DetailPanels/BasicInfo";
import DetailInfo from "./DetailPanels/DetailInfo";
import CheckingStatusInfo from "./DetailPanels/CheckingStatusInfo";
import Photo from "./DetailPanels/Photo";
import RelatedReport from "./DetailPanels/RelatedReport";
import S1Report from "./DetailPanels/S1Report";
import S23Report from "./DetailPanels/S23Report";
import MMReport from "./DetailPanels/MMReport";
import ESFS from "./DetailPanels/ESFS";
import LDSPanel from "components/LDSPanel";
import eLPMIS from "./DetailPanels/eLPMIS";
import React from "react";
import GetArcGISToken from "utils/GetArcGISToken";
import LayerToggleUtil from "utils/LayerToggleUtil";
import slopeNoFormat from "utils/slopeNoFormat";
import { updateSearchResults } from "store/globalSlice";

const ITEM_DETAIL_INFO = [
  {
    title: "Basic",
    url: "ManMadeFeature",
    panelClass: BasicInfo,
  },
  {
    title: "Detail",
    url: "ManMadeFeature",
    panelClass: DetailInfo,
    displayedByDataInField: "FEATURE",
  },
  {
    title: "Photo",
    url: "Photos",
    panelClass: Photo,
  },
  {
    title: "Checking Status",
    url: "ManMadeFeature",
    panelClass: CheckingStatusInfo,
    displayedByDataInField: "CheckingStatusInformations",
  },
  {
    title: "Related Report",
    url: "ManMadeFeature",
    panelClass: RelatedReport,
    displayedByDataInField: "FEATURE",
  },
  {
    title: "S1 Report",
    url: "ManMadeFeature",
    panelClass: S1Report,
    displayedByDataInField: "S1Report",
  },
  { title: "S2/3 Report", url: "S23Reports", panelClass: S23Report },
  { title: "MM Report", url: "MMReports", panelClass: MMReport },
  { title: "ESFS", url: "ESFSUrl", panelClass: ESFS },
  { title: "eLPMIS", url: "S23StudyWorks", panelClass: eLPMIS },
];
let cachedData = {};
let cachedMMSInfo = {};
class ItemDetail extends IComponent {
  tabReadyStatus = {};
  constructor(props) {
    super(props);
    this.state = {
      detailPage: -1,
      tabList: [],
      turn3DOn: false,
      item: {},
    };
    this.tabReadyStatus = {};
  }
  componentDidMount() {
    this.checklength().then((i) => {
      this.queryItemDetail(i);
    });
    // this.queryItemDetail();
  }
  componentWillUnmount() {}

  async checklength() {
    let p = {};
    try {
      let url = `${this.$config.ManMadeSlopeInfoList.S23ReportUrl}`;
      let S23data = {
        Key: this.props.item.text,
      };
      var queryTexturalResults;
      queryTexturalResults = await this.fetchQueryByPOST(url, S23data);
      var treeViewResult = await queryTexturalResults.json();
      p["STWOTHREE"] = treeViewResult;
      let MMurl = `${this.$config.ManMadeSlopeInfoList.MMReportUrl}`;
      let MMdata = {
        Key: this.props.item.text,
      };
      var queryTexturalResults;
      queryTexturalResults = await this.fetchQueryByPOST(MMurl, MMdata);
      var treeViewResult = await queryTexturalResults.json();
      p["MM"] = treeViewResult;
    } catch (e) {
      console.debug(e);
    }
    return p;
  }

  async queryItemDetail(obj) {
    let item = await this.queryForSlopeDetail(this.props.item);
    item.attributes["ManMadeSlope_FEATURE"] = item.key;
    const user = GetArcGISToken.user;
    const attr = item.attributes;
    let tabList = ITEM_DETAIL_INFO.reduce((p, i) => {
      let checkResult = false;
      switch (i.title) {
        case "S2/3 Report":
          checkResult =
            !!obj?.STWOTHREE &&
            obj?.STWOTHREE?.length > 0 &&
            [4, 5, 6].includes(user?.userGroup);
          break;
        case "MM Report":
          checkResult =
            !!obj?.MM && obj?.MM?.length > 0 && user?.userGroup === 4;
          break;
        case "ESFS":
          checkResult = ![4, 5, 6].includes(user?.userGroup);
          break;
        case "S1 Report":
          checkResult = attr.S1Report.S1_FEATURE !== "N/A";
          break;
        default:
          // "Basic", "Related Report" , 'Photo', 'Checking Status', 'eLPMIS'
          let checkFieldEmpty = "displayedByDataInField" in i;
          let fieldName = checkFieldEmpty && i.displayedByDataInField;
          let data = attr[fieldName];
          checkResult =
            !checkFieldEmpty ||
            !((checkFieldEmpty && data === "N/A") || data.length === 0);
          break;
      }
      if (checkResult) p.push({ data: undefined, tabInfo: i });
      return p;
    }, []);
    this.setState({ tabList, item });
  }
  async queryForSlopeDetail(resultItem) {
    if (cachedMMSInfo[resultItem.key]) return cachedMMSInfo[resultItem.key];
    // let slopeNo = resultItem.attributes?.FEATURE;
    let url = `${this.$config.ManMadeSlopeInfoList.ManMadeFeatureUrl}`;
    let result = await this.fetchQueryByPOST(url, {
      Key: resultItem.key,
    });
    result = await result.json();
    // if (!result.FEATURE) result.FEATURE = slopeNo;
    return (cachedMMSInfo[resultItem.key] = {
      ...resultItem,
      attributes: result,
    });
  }
  handleItemUnmount(title) {
    let tmpTabList = this.state.tabList;
    tmpTabList = tmpTabList.filter((i) => i.tabInfo.title !== title);
    this.setState({ tabList: tmpTabList });
  }
  checkTabReadyStatus() {
    let stateTabStatus = this.state.tabList;
    let classTabStatus = Object.keys(this.tabReadyStatus);
    if (classTabStatus.length >= stateTabStatus.length) {
      let tabList = stateTabStatus.filter((i, j) => this.tabReadyStatus[j]);
      this.setState({ tabList, detailPage: 0 });
    }
  }
  getSensorLayer(slopeName) {
    let component = React.createElement(LDSPanel, this.props);
    let instance = new component.type(this.props);
    instance.props = this.props;

    let sensorLayer = instance.createSensorLayer();
    sensorLayer.definitionExpression = `SLOPE_NO_ = '${slopeName}'`;

    this.props.mapView.map.add(sensorLayer);
    instance.updateFeatureLayerRenderer(sensorLayer);
    instance.intervalFunctionForChangingSensorColor(sensorLayer);

    return sensorLayer;
  }
  showRelated3DLayer(slopeNo) {
    slopeNo = slopeNoFormat.FeatureNo13Char(slopeNo);
    let relatedSlopeItems = ["BIM Model", "Man-made Feature"].reduce(
      (p1, c1, i1) => {
        p1[c1] = this.$config.mapList.layer3D[c1].reduce((p, c, index) => {
          if ((c.metaData?.slopeNo || {})[slopeNo]) {
            p.push(index);
          }
          return p;
        }, []);

        if (p1[c1].length === 0) delete p1[c1];

        return p1;
      },
      {}
    );

    return relatedSlopeItems;
  }
  render() {
    let vm = this;
    let { tabList, detailPage, turn3DOn } = this.state;
    return (
      <div className="ItemDetailContainer">
        <div className="EqualWidthChildren">
          <div
            style={!this.props.showBackButton ? { display: "none" } : {}}
            className="BackButton"
            onClick={() => this.props.onSubPanelCallback("goBack")}
          >
            <span className="icn_back" />
          </div>
          <div className="Shrink2 ResultItemName">
            &nbsp;{this.props.item.text}
          </div>
          {this.props.reduxStore.global.mapType == 3 && (
            <div>
              <SwitchButton
                label="Show related 3D data"
                placeAtRight={true}
                checked={turn3DOn}
                labelalignment="right"
                onClick={() => {
                  LayerToggleUtil.removeAdded3DLayers(this.props.mapView);
                  turn3DOn = !turn3DOn;
                  if (turn3DOn === true) {
                    let slopeItemResult = this.showRelated3DLayer(
                      this.state.item.text
                    );
                    this.props.reduxCallProxy(
                      updateSearchResults,
                      slopeItemResult
                    );
                    let resultExpandBtn = document.getElementById(
                      "3DLayerSearchResult"
                    );
                    if (
                      !resultExpandBtn.querySelector(
                        ".esri-expand__mask--expanded"
                      )
                    )
                      resultExpandBtn
                        .querySelector(".esri-widget--button")
                        .click();
                  }

                  this.setState({ turn3DOn });
                }}
              />
            </div>
          )}
        </div>
        <div style={{ height: "calc(100% - 55px)" }}>
          {detailPage > -1 && (
            <SwitchTabs
              tabText={tabList.map((i) => i.tabInfo.title)}
              onSwitchTabCallback={(e) => this.setState({ detailPage: e })}
            />
          )}
          {detailPage == -1 && (
            <div className="DetailLoadingSign">
              <span className="icn_loading" />
              Loading the item detail...
            </div>
          )}
          {tabList.map((i, j) => (
            <div
              key={"PANEL" + j}
              className="ItemDetailPage"
              style={{ display: j == detailPage ? "block" : "none" }}
            >
              {React.createElement(i.tabInfo.panelClass, {
                ...this.state.item,
                ...this.props,
                cachedData: cachedData[this.state.item.key]?.[i.tabInfo.title],
                title: i.tabInfo.title,
                onCachePanelData: (title, data) => {
                  if (!cachedData[this.state.item.key])
                    cachedData[this.state.item.key] = {};
                  cachedData[this.state.item.key][title] = data;
                },
                isShowTabCallback: (e) => {
                  console.debug(j, "isShowTabCallback", e);
                  this.tabReadyStatus[j] = e;
                  this.checkTabReadyStatus();
                },
              })}
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default ItemDetail;
